/**
 * Mock customer data for testing and development
 */
export const mockCustomers = [
  // Youth (青少年)
  {
    id: 'youth-001',
    name: '林晨',
    phoneNumber: '13900001111',
    email: 'linchen@example.com',
    birthdate: '2010-05-20',
    age: 14,
    gender: '男',
    address: '北京市朝阳区望京花园',
    notes: '身高偏矮，挑食，家长关注成长发育',
    tags: ['青少年', '成长发育', '雏英高飞'],
    customerType: 'new',
    ageGroup: 'youth',
    height: 150,
    weight: 40,
    lifestyle: {
      diet: '偏爱零食，蔬菜摄入少',
      sleep: '作息规律，22:00入睡',
      exercise: '每周打篮球2次'
    },
    familyHistory: ['父亲有哮喘'],
    currentSymptoms: ['身高增长缓慢', '挑食', '体质偏弱'],
    intendedProject: '雏英高飞',
    intendedPractitioner: '吴磊',
    specialNeeds: '无',
    healthProfile: {
      growthConcern: true,
      allergies: [],
      schoolPerformance: '良好'
    }
  },
  {
    id: 'youth-002',
    name: '周子涵',
    phoneNumber: '13900001112',
    email: 'zhouzihan@example.com',
    birthdate: '2011-09-10',
    age: 13,
    gender: '女',
    address: '北京市海淀区紫竹院路',
    notes: '体重偏轻，胃口一般，家长关注免疫力',
    tags: ['青少年', '免疫力', '雏英高飞'],
    customerType: 'new',
    ageGroup: 'youth',
    height: 145,
    weight: 35,
    lifestyle: {
      diet: '偏爱主食，蔬菜水果较少',
      sleep: '23:00入睡，偶尔熬夜',
      exercise: '每周游泳1次'
    },
    familyHistory: ['母亲有过敏性鼻炎'],
    currentSymptoms: ['易感冒', '胃口差'],
    intendedProject: '雏英高飞',
    intendedPractitioner: '谢代清',
    specialNeeds: '对海鲜过敏',
    healthProfile: {
      growthConcern: false,
      allergies: ['海鲜'],
      schoolPerformance: '中等'
    }
  },
  {
    id: 'youth-003',
    name: '李嘉豪',
    phoneNumber: '13900001113',
    email: 'lijihao@example.com',
    birthdate: '2009-12-01',
    age: 15,
    gender: '男',
    address: '北京市丰台区南苑路',
    notes: '青春期发育迟缓，注意力不集中',
    tags: ['青少年', '发育迟缓'],
    customerType: 'returning',
    ageGroup: 'youth',
    height: 155,
    weight: 43,
    lifestyle: {
      diet: '偏爱肉类，蔬菜较少',
      sleep: '22:30入睡，周末熬夜',
      exercise: '偶尔打羽毛球'
    },
    familyHistory: ['父亲有近视'],
    currentSymptoms: ['发育迟缓', '注意力不集中'],
    intendedProject: '雏英高飞',
    intendedPractitioner: '吴磊',
    specialNeeds: '',
    healthProfile: {
      growthConcern: true,
      allergies: [],
      schoolPerformance: '一般'
    }
  },
  // Sub-healthy Adult (成年人亚健康)
  {
    id: 'adult-001',
    name: '王蕾',
    phoneNumber: '13900002222',
    email: 'wanglei@example.com',
    birthdate: '1988-09-12',
    age: 35,
    gender: '女',
    address: '北京市海淀区中关村公寓',
    notes: '工作压力大，睡眠质量差，易疲劳',
    tags: ['亚健康', '压力大', '君子立本'],
    customerType: 'returning',
    ageGroup: 'adult',
    height: 162,
    weight: 58,
    lifestyle: {
      diet: '外卖较多，偶尔暴饮暴食',
      sleep: '经常熬夜，平均6小时',
      exercise: '每周瑜伽1次'
    },
    familyHistory: ['母亲有高血压', '父亲有糖尿病'],
    currentSymptoms: ['失眠', '乏力', '情绪波动'],
    intendedProject: '君子立本',
    intendedPractitioner: '李锡涛',
    specialNeeds: '对薰衣草精油过敏',
    healthProfile: {
      stressLevel: '高',
      sleepQuality: '差',
      digestion: '偶有胃胀'
    }
  },
  {
    id: 'adult-002',
    name: '陈伟',
    phoneNumber: '13900002223',
    email: 'chenwei@example.com',
    birthdate: '1990-03-18',
    age: 34,
    gender: '男',
    address: '北京市朝阳区建国门外大街',
    notes: '久坐办公，腰背酸痛，运动少',
    tags: ['亚健康', '久坐', '腰背痛'],
    customerType: 'new',
    ageGroup: 'adult',
    height: 175,
    weight: 75,
    lifestyle: {
      diet: '高油高盐，饮水少',
      sleep: '23:30入睡，睡眠浅',
      exercise: '每月健身房2次'
    },
    familyHistory: ['父亲有高血脂'],
    currentSymptoms: ['腰背酸痛', '易疲劳'],
    intendedProject: '亚健康调理',
    intendedPractitioner: '王志国',
    specialNeeds: '',
    healthProfile: {
      stressLevel: '中',
      sleepQuality: '一般',
      digestion: '油腻不适'
    }
  },
  {
    id: 'adult-003',
    name: '刘欣',
    phoneNumber: '13900002224',
    email: 'liuxin@example.com',
    birthdate: '1985-07-25',
    age: 39,
    gender: '女',
    address: '北京市石景山区苹果园',
    notes: '易焦虑，肠胃不适，体重波动',
    tags: ['亚健康', '焦虑', '肠胃'],
    customerType: 'returning',
    ageGroup: 'adult',
    height: 160,
    weight: 54,
    lifestyle: {
      diet: '素食为主，偶尔暴饮暴食',
      sleep: '22:00入睡，易醒',
      exercise: '每周快走3次'
    },
    familyHistory: ['母亲有甲状腺结节'],
    currentSymptoms: ['焦虑', '肠胃不适', '体重波动'],
    intendedProject: '君子立本',
    intendedPractitioner: '谢代清',
    specialNeeds: '',
    healthProfile: {
      stressLevel: '高',
      sleepQuality: '一般',
      digestion: '肠胃敏感'
    }
  },
  // Senior (老年人)
  {
    id: 'senior-001',
    name: '赵国强',
    phoneNumber: '13900003333',
    email: 'zhaoguoqiang@example.com',
    birthdate: '1950-03-05',
    age: 74,
    gender: '男',
    address: '北京市西城区什刹海小区',
    notes: '高血压史，腿脚不便，需定期调理',
    tags: ['老年人', '慢病调理', '高血压'],
    customerType: 'returning',
    ageGroup: 'senior',
    height: 168,
    weight: 65,
    lifestyle: {
      diet: '清淡饮食，低盐低脂',
      sleep: '早睡早起，夜间易醒',
      exercise: '每天散步30分钟'
    },
    familyHistory: ['父亲有高血压', '母亲有心脏病'],
    currentSymptoms: ['血压偏高', '腿部酸胀', '夜尿频繁'],
    intendedProject: '慢病调理',
    intendedPractitioner: '王志国',
    specialNeeds: '需轮椅通道',
    healthProfile: {
      chronicDiseases: ['高血压'],
      medication: ['降压药'],
      mobility: '需辅助器具'
    }
  },
  {
    id: 'senior-002',
    name: '孙玉兰',
    phoneNumber: '13900003334',
    email: 'sunyl@example.com',
    birthdate: '1948-11-22',
    age: 76,
    gender: '女',
    address: '北京市丰台区南苑小区',
    notes: '糖尿病史，视力下降，需饮食管理',
    tags: ['老年人', '糖尿病', '饮食管理'],
    customerType: 'returning',
    ageGroup: 'senior',
    height: 158,
    weight: 60,
    lifestyle: {
      diet: '低糖饮食，定时三餐',
      sleep: '21:30入睡，夜间易醒',
      exercise: '每天小区散步'
    },
    familyHistory: ['父亲有糖尿病'],
    currentSymptoms: ['血糖偏高', '视力下降'],
    intendedProject: '慢病调理',
    intendedPractitioner: '李锡涛',
    specialNeeds: '需低糖饮食',
    healthProfile: {
      chronicDiseases: ['糖尿病'],
      medication: ['降糖药'],
      mobility: '可独立行走'
    }
  },
  {
    id: 'senior-003',
    name: '马建国',
    phoneNumber: '13900003335',
    email: 'majg@example.com',
    birthdate: '1945-06-15',
    age: 79,
    gender: '男',
    address: '北京市朝阳区团结湖',
    notes: '冠心病史，行动缓慢，需家属陪同',
    tags: ['老年人', '冠心病', '陪同'],
    customerType: 'new',
    ageGroup: 'senior',
    height: 165,
    weight: 62,
    lifestyle: {
      diet: '低脂饮食，少量多餐',
      sleep: '22:00入睡，午休1小时',
      exercise: '每周康复操2次'
    },
    familyHistory: ['母亲有冠心病'],
    currentSymptoms: ['胸闷', '乏力', '行动缓慢'],
    intendedProject: '康复保健',
    intendedPractitioner: '王志国',
    specialNeeds: '需家属陪同',
    healthProfile: {
      chronicDiseases: ['冠心病'],
      medication: ['心脏药'],
      mobility: '需搀扶'
    }
  }
];

export default mockCustomers; 